/** The creative lifecycle pill: draft, in review, approved, archived. */

const COLORS: Record<string, string> = {
  approved: 'var(--good)',
  review: 'var(--warn)',
  draft: 'var(--ink-3)',
  archived: 'var(--ink-3)',
};

const LABELS: Record<string, string> = {
  approved: 'APPROVED',
  review: 'IN REVIEW',
  draft: 'DRAFT',
  archived: 'ARCHIVED',
};

export function statusColor(status: string): string {
  return COLORS[status] ?? 'var(--ink-3)';
}

export function StatusPill({ status }: { status: string }) {
  const color = statusColor(status);
  return (
    <span
      className="tag status-pill"
      data-status={status}
      style={{ borderColor: color, color, background: 'transparent', fontWeight: 700 }}
    >
      <span className="dot" style={{ background: color }} />
      {LABELS[status] ?? status.toUpperCase()}
    </span>
  );
}
